<template>
    <div>
        <b-card>
            <div slot="header">
                <span class="font-weight-bold">{{ accion }} inspección</span>
                <b-button
                    to="/listas-chequeo"
                    size="sm"
                    variant="secondary"
                    class="float-right"
                >
                    <i class="fa fa-reply fa-lg" /> Volver
                </b-button>
            </div>
            <b-tabs v-model="tabIndex">
                <b-tab active>
                    <template v-slot:title>
                        <i class="el-icon-date"></i> Registro de Hallazgos
                    </template>
                    <form
                        data-vv-scope="formulario"
                        @submit.prevent="validarFormulario"
                    >
                        <b-row>
                            <b-col sm="4" v-if="mostrar_empresas">
                                <label for="id_empresa">Empresa</label>
                                <el-select
                                    id="id_empresa"
                                    name="id_empresa"
                                    v-model="selectedListaChequeo.id_empresa"
                                    filterable
                                    remote
                                    :disabled="accion === 'Actualizar'"
                                    v-if="
                                        this.validarPermiso('listar-hallazgos')
                                    "
                                    size="small"
                                    data-vv-as=" "
                                    v-validate="'required'"
                                    no-data-text="No hay datos que coincidan"
                                    no-match-text="No hay datos que coincidan"
                                    @change="getPlaneacionHallazgos"
                                    :remote-method="obtenerEmpresas"
                                >
                                    <el-option
                                        v-for="item in empresas"
                                        :key="item.id"
                                        :label="item.nombre"
                                        :value="item.id"
                                    />
                                </el-select>
                                <span
                                    class="text-danger span-error small"
                                    v-text="
                                        errors.first('formulario.id_empresa')
                                    "
                                />
                            </b-col>

                            <b-col sm="4">
                                <label for="id_tipo_lista_chequeo"
                                    >Lista de Chequeo</label
                                >
                                <el-select
                                    id="id_tipo_lista_chequeo"
                                    name="id_tipo_lista_chequeo"
                                    v-model="
                                        selectedListaChequeo.id_tipo_lista_chequeo
                                    "
                                    filterable
                                    :disabled="
                                        accion === 'Actualizar' ||
                                        !selectedListaChequeo.id_empresa
                                    "
                                    size="small"
                                    data-vv-as=" "
                                    v-validate="'required'"
                                    @change="listarTipoSeg"
                                >
                                    <el-option
                                        v-for="item in tipoListaChequeo"
                                        :key="item.id"
                                        :label="item.tipo_lista"
                                        :value="item.id"
                                    />
                                </el-select>
                                <span
                                    class="text-danger span-error small"
                                    v-text="
                                        errors.first(
                                            'formulario.id_tipo_lista_chequeo'
                                        )
                                    "
                                />
                            </b-col>

                            <b-col
                                sm="4"
                                class="form-group"
                                v-if="
                                    selectedListaChequeo.seleccionar_ubicacion
                                "
                            >
                                <label for="id_ubicacion" class="w-100">
                                    Ubicación
                                    <b-form-checkbox
                                        v-model="
                                            selectedListaChequeo.seleccionar_ubicacion
                                        "
                                        v-if="accion === 'Crear'"
                                        :disabled="
                                            !selectedListaChequeo.id_empresa
                                        "
                                        class="float-right"
                                        @change="establecerIdUbicacion(null)"
                                        v-b-tooltip.top.hover="
                                            'Digitar ubicación'
                                        "
                                        :value="true"
                                        :unchecked-value="false"
                                    />
                                </label>
                                <tree-select
                                    :value="selectedListaChequeo.id_ubicacion"
                                    class="text-uppercase"
                                    size="sm"
                                    id="id_ubicacion"
                                    name="id_ubicacion"
                                    :multiple="false"
                                    :defaultExpandLevel="Infinity"
                                    :options="ubicaciones"
                                    :disabled="
                                        !selectedListaChequeo.id_empresa ||
                                        accion !== 'Crear'
                                    "
                                    @input="establecerIdUbicacion"
                                    data-vv-as=" "
                                    v-validate="'required'"
                                    :normalizer="your_normalizer"
                                />
                                <span
                                    class="text-danger span-error small"
                                    v-text="
                                        errors.first('formulario.id_ubicacion')
                                    "
                                />
                            </b-col>
                            <b-col sm="4" v-else>
                                <b-form-group>
                                    <label for="unidad_negocio" class="w-100">
                                        Ubicación
                                        <b-form-checkbox
                                            v-model="
                                                selectedListaChequeo.seleccionar_ubicacion
                                            "
                                            v-if="accion === 'Crear'"
                                            :disabled="
                                                !selectedListaChequeo.id_empresa
                                            "
                                            class="float-right"
                                            @change="
                                                establecerIdUbicacion(null)
                                            "
                                            v-b-tooltip.top.hover="
                                                'Seleccionar ubicación'
                                            "
                                            :value="true"
                                            :unchecked-value="false"
                                        />
                                    </label>
                                    <b-form-input
                                        type="text"
                                        id="unidad_negocio"
                                        name="unidad_negocio"
                                        data-vv-as=" "
                                        v-validate="'required|max:255'"
                                        v-model="
                                            selectedListaChequeo.unidad_negocio
                                        "
                                        :disabled="
                                            !selectedListaChequeo.id_empresa ||
                                            accion !== 'Crear'
                                        "
                                    />
                                    <span
                                        class="text-danger span-error small"
                                        v-text="
                                            errors.first(
                                                'formulario.unidad_negocio'
                                            )
                                        "
                                    />
                                </b-form-group>
                            </b-col>

                            <b-col sm="4">
                                <b-form-group>
                                    <label for="fecha_inicio_visita"
                                        >Fecha de inspección</label
                                    >
                                    <el-date-picker
                                        v-model="
                                            selectedListaChequeo.fecha_inicio_visita
                                        "
                                        id="fecha_inicio_visita"
                                        name="fecha_inicio_visita"
                                        data-vv-as=" "
                                        v-validate="
                                            'required|date_format:yyyy-MM-dd HH:mm:ss'
                                        "
                                        type="datetime"
                                        class="w-100"
                                        size="small"
                                        placeholder="Fecha Inicio Visita"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                    />
                                    <span
                                        class="text-danger span-error small"
                                        v-text="
                                            errors.first(
                                                'formulario.fecha_inicio_visita'
                                            )
                                        "
                                    />
                                </b-form-group>
                            </b-col>

                            <!-- Responsable -->
                            <b-col sm="3" class="form-group">
                                <label for="responsable"> Responsable </label>
                                <el-select
                                    id="responsable"
                                    name="responsable"
                                    v-model="selectedListaChequeo.wor_worker_id"
                                    :disabled="
                                        !selectedListaChequeo.id_empresa ||
                                        !workersList.length
                                    "
                                    placeholder="Seleccionar responsable"
                                    clearable
                                    filterable
                                    size="small"
                                    data-vv-as=" "
                                    v-validate="'required'"
                                >
                                    <el-option
                                        v-for="item in workersList"
                                        :key="item.id"
                                        :label="item.fullName"
                                        :value="item.id"
                                    />
                                </el-select>
                                <span
                                    class="text-danger span-error small"
                                    v-text="
                                        errors.first('formulario.responsable')
                                    "
                                />
                            </b-col>

                            <b-col
                                style="margin-top: 30px"
                                sm="1"
                                class="form-group"
                            >
                            <b-button
                                    :disabled="!selectedListaChequeo.id_empresa"
                                    variant="warning"
                                    size="sm"
                                    class="ml-1"
                                    v-b-tooltip.hover
                                    title="Ver trabajador"
                                    @click="showModalInfoWorker"
                                >
                                <i class="fa fa-eye" aria-hidden="true"></i>
                                </b-button>
                                <b-button
                                    :disabled="!selectedListaChequeo.id_empresa"
                                    variant="primary"
                                    size="sm"
                                    class="ml-1"
                                    v-b-tooltip.hover
                                    title="Crear trabajador"
                                    @click="showModalAddWorker"
                                    v-b-modal.modal-form-worker
                                >
                                    <i class="fa fa-plus"></i>
                                </b-button>
                            </b-col>

                            <b-col sm="4">
                                <b-form-group>
                                    <label for="proximo_seguimiento"
                                        >Fecha de seguimiento</label
                                    >
                                    <el-date-picker
                                        v-model="
                                            selectedListaChequeo.proximo_seguimiento
                                        "
                                        id="proximo_seguimiento"
                                        name="proximo_seguimiento"
                                        data-vv-as=" "
                                        v-validate="
                                            'required|date_format:yyyy-MM-dd'
                                        "
                                        type="date"
                                        class="w-100"
                                        size="small"
                                        placeholder="Fecha Proximo Seguimiento"
                                        value-format="yyyy-MM-dd"
                                    />
                                    <span
                                        class="text-danger span-error small"
                                        v-text="
                                            errors.first(
                                                'formulario.proximo_seguimiento'
                                            )
                                        "
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="4">
                                <b-form-group>
                                    <label for="observacion_general"
                                        >Observaciónes</label
                                    >
                                    <b-form-input
                                        type="text"
                                        id="observacion_general"
                                        name="observacion_general"
                                        data-vv-as=" "
                                        v-validate="'max:255'"
                                        v-model="
                                            selectedListaChequeo.observacion_general
                                        "
                                    />
                                    <span
                                        class="text-danger span-error small"
                                        v-text="
                                            errors.first(
                                                'formulario.observacion_general'
                                            )
                                        "
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="4" v-if="accion === 'Crear'">
                                <b-form-group>
                                    <label
                                        for="observacion_general"
                                        style="
                                            margin-right: 0.7rem;
                                            margin-bottom: 0;
                                        "
                                    >
                                        ¿Cargar planeación?
                                        <el-checkbox
                                            v-model="planeacionCargar"
                                            :disabled="
                                                !selectedListaChequeo.id_tipo_lista_chequeo ||
                                                !selectedListaChequeo.id_empresa
                                            "
                                        />
                                    </label>
                                    <el-select
                                        v-model="
                                            selectedListaChequeo.planeacion
                                        "
                                        @focus="getPlaneacion"
                                        size="small"
                                        :disabled="!planeacionCargar"
                                    >
                                        <el-option
                                            v-for="(
                                                item, index
                                            ) in planeacionesAuditoriasHallazgos"
                                            :key="item.id"
                                            :label="item.objetivo"
                                            :value="item.id"
                                        />
                                    </el-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </form>

                    <!-- Hallazgos -->
                    <div v-if="accion === 'Actualizar'">
                        <hr />
                        <hallazgos ref="findingsRef" />
                    </div>
                </b-tab>

                <!-- Graficas de Cumplimiento -->
                <b-tab :disabled="accion !== 'Actualizar'">
                    <template v-slot:title>
                        <i class="fa fa-bar-chart-o"></i> Graficas de
                        Cumplimiento
                    </template>
                    <resultado-riesgo-quimico v-if="tabIndex === 1" />
                </b-tab>

                <!-- Plan de Acción -->
                <b-tab :disabled="accion !== 'Actualizar'">
                    <template v-slot:title>
                        <i class="fa fa-calendar-check-o"></i> Plan de Acción
                    </template>
                    <planAccion v-if="tabIndex === 2" />
                </b-tab>
            </b-tabs>

            <b-row v-if="tabIndex === 0" class="mt-3">
                <b-col class="text-center">
                    <b-button
                        v-if="validarPermiso('listar-hallazgos')"
                        @click.prevent="validarFormulario"
                        size="sm"
                        variant="primary"
                    >
                        <i class="fa fa-floppy-o fa-lg" /> Guardar
                    </b-button>

                    <b-button
                        to="/listas-chequeo"
                        size="sm"
                        variant="secondary"
                        class="float-left"
                    >
                        <i class="fa fa-reply fa-lg" /> Volver
                    </b-button>
                </b-col>
            </b-row>
        </b-card>

        <!--============================
        Modal formworker
      ==============================-->
        <b-modal
            hide-footer
            size="lg"
            title="Crear trabajador"
            id="modal-form-worker"
        >
            <FormWorker
                :company_id="selectedListaChequeo.id_empresa"
                @saveWorker="_saveWorker"
                :showAddPosition="true"
            />
        </b-modal>

        <b-modal
            id="modal-worker-details"
            title="Detalles del Trabajador"
            size="lg"
            hide-footer
            class="worker-details-modal"
        >
            <template v-if="selectedWorker">
                <div class="worker-profile p-4">
                    <div class="profile-header mb-4 text-center">
                        <div class="avatar-wrapper mb-3">
                            <div class="avatar-circle" :style="{ backgroundColor: getAvatarColor(selectedWorker) }">
                                <span class="initials">{{ getInitials(selectedWorker) }}</span>
                                <div class="avatar-status" :class="{ 'status-active': selectedWorker.active }">
                                    <span class="status-dot"></span>
                                </div>
                            </div>
                        </div>
                        <h3 class="mb-1">{{ selectedWorker.names }} {{ selectedWorker.surnames }}</h3>
                        <p class="text-muted">{{ selectedWorker.sys_list_identification_type.lista }} - {{ selectedWorker.identification }}</p>
                    </div>
                    <b-row>
                        <b-col md="6">
                            <b-card class="mb-3">
                                <h5 class="card-title">
                                    <i class="fa fa-user-circle-o mr-2"></i>
                                    Información Personal
                                </h5>
                                <b-list-group flush>
                                    <b-list-group-item>
                                        <strong>Email:</strong> {{ selectedWorker.email }}
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <strong>Teléfono:</strong> {{ selectedWorker.phone }}
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <strong>Estado:</strong>
                                        <b-badge :variant="selectedWorker.active ? 'success' : 'danger'">
                                            {{ selectedWorker.active ? 'Activo' : 'Inactivo' }}
                                        </b-badge>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-card>
                        </b-col>
                        <b-col md="6">
                        <b-card>
                            <h5 class="card-title">
                                <i class="fa fa-briefcase mr-2"></i>
                                Posiciones
                            </h5>
                            <div class="position-timeline">
                                <template v-if="selectedWorker.wor_worker_positions.length">
                                    <div v-for="position in selectedWorker.wor_worker_positions"
                                        :key="position.id"
                                        class="position-item">
                                        <div class="position-date">
                                            {{ formatDate(position.start_date) }} -
                                            {{ position.finish_date ? formatDate(position.finish_date) : 'Presente' }}
                                        </div>
                                        <div class="position-info" v-if="position.wor_position_id">
                                            <div class="text-truncate">
                                                <b-badge variant="info" class="position-badge">
                                                    Posición {{ position.wor_position.code }} - {{ position.wor_position.name }}
                                                </b-badge>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <p v-else class="text-muted">No hay posiciones registradas</p>
                            </div>
                        </b-card>
                    </b-col>
                    </b-row>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

import hallazgos from "./hallazgos";
import resultadoRiesgoQuimico from "./resultadoRiesgoQuimico";
import planAccion from "./planAccion";
import TreeSelect from "@riophae/vue-treeselect";
import { getAcls } from "../../plugins/acl";
import FormWorker from "../workers/workers/components/FormWorker.vue";

export default {
    name: "registro-hallazgos",
    components: {
        hallazgos,
        resultadoRiesgoQuimico,
        planAccion,
        TreeSelect,
        FormWorker,
    },
    data() {
        return {
            mostrar_empresas: true,
            tabIndex: 0,
            planeacionCargar: false,
            selectedWorker: null
        };
    },
    async created() {
        const id_lista = this.$route.params.id_lista;
        const id_empresa = this.$route.params.id_empresa;

        let acls = getAcls();

        this.mostrar_empresas = !!acls.roles.filter((r) =>
            ["superadmin", "admin", "admin-tecnico"].includes(r)
        ).length;

        if (!this.mostrar_empresas) {
            const id_empresa = await this.obtenerIdEmpresaUsuario();

            this.establecerIdEmpresaSelectedListaChequeo(id_empresa);
            await this.listarTipoListaChequeo(id_empresa);
            await this.obtenerUbicaciones(id_empresa);
        }

        if (id_lista && id_empresa) {
            await this.initUpdate(id_lista, id_empresa);
        } else {
            this.setAccion("Crear");
        }

        this.load(false);
    },
    methods: {
        ...mapActions("findings", ["getResponsibles"]),
        ...mapActions("workers", ["saveWorker"]),
        ...mapMutations("workers", ["resetWorker"]),
        showModalAddWorker() {
            this.resetWorker();
            this.$bvModal.hide("modal-form-worker");
        },
        showModalInfoWorker() {
            this.selectedWorker = this.workersList.find(
                worker => worker.id === this.selectedListaChequeo.wor_worker_id
            );
            this.$bvModal.show('modal-worker-details');
        },
        getInitials(worker) {
            return `${worker.names.charAt(0)}${worker.surnames.charAt(0)}`;
        },
        formatDate(date) {
            return new Date(date).toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        },
        getAvatarColor(worker) {
            // Generate a consistent color based on the worker's name
            let hash = 0;
            const str = worker.names + worker.surnames;
            for (let i = 0; i < str.length; i++) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
            }
            // Use predefined professional colors
            const colors = [
                '#4CAF50', '#2196F3', '#9C27B0', '#FF9800',
                '#E91E63', '#3F51B5', '#009688', '#795548'
            ];
            const index = Math.abs(hash) % colors.length;
            return colors[index];
        },
        async _saveWorker() {
            await this.saveWorker(this.selectedListaChequeo.id_empresa).then(
                async () => {
                    this.$bvModal.hide("modal-form-worker");
                    await this.getResponsibles(
                        this.selectedListaChequeo.id_empresa
                    );
                }
            );
        },
        your_normalizer(node) {
            return {
                children:
                    node.children && node.children.length ? node.children : 0,
            };
        },
        async getPlaneacionHallazgos(id_empresa) {
            await this.listarTipoListaChequeo(id_empresa);

            await this.obtenerUbicaciones(id_empresa);

            const data = {
                id_empresa: this.selectedListaChequeo.id_empresa,
                id_tipo_lista_chequeo:
                    this.selectedListaChequeo.id_tipo_lista_chequeo,
                sortBy: "id",
                sort: "DESC",
            };

            await this.setFiltro(data);
            this.selectedListaChequeo.planeacion = [];
        },
        async initUpdate(id_lista, id_empresa) {
            this.setAccion("Actualizar");
            await this.mostrarListaChequeo({ id_lista, id_empresa });
            await this.listarTipoSeg();
        },
        async validarFormulario() {
            await this.$validator
                .validateAll("formulario")
                .then(async (result) => {
                    if (result) {
                        if (this.accion === "Crear") {
                            await this.crearListaChequeo().then(() => {
                                this.$router.push(
                                    `/editar-hallazgo/${this.selectedListaChequeo.id}/${this.selectedListaChequeo.id_empresa}`
                                );
                                this.initUpdate(
                                    this.selectedListaChequeo.id,
                                    this.selectedListaChequeo.id_empresa
                                );
                            });
                        } else if (this.accion === "Actualizar") {
                            let location;
                            try {
                                location =
                                    this.$refs.findingsRef.searchLocationByIdIncludesYourChildrens(
                                        this.ubicaciones,
                                        this.selectedListaChequeo.id_ubicacion
                                    );
                            } catch (e) {
                                location = null;
                            }
                            this.setLocationNameToCheckList(
                                location ? location.label : "No aplica"
                            );

                            await this.actualizarListaChequeo();
                        }
                    }
                });
        },
        ...mapActions("listaChequeo", [
            "crearListaChequeo",
            "listarTipoSeg",
            "listarHallazgos",
            "listarTipoListaChequeo",
            "mostrarListaChequeo",
            "oportunidadesMejora",
            "actualizarListaChequeo",
            "obtenerEmpresas",
            "verGraficas",
            "verPlanAccion",
            "getPlaneacion",
            "obtenerUbicaciones",
        ]),
        ...mapMutations("dashboard", ["load"]),
        ...mapActions("dashboard", [
            "validarPermiso",
            "obtenerIdEmpresaUsuario",
        ]),
        ...mapMutations("planeacionAuditoria", [
            "setFiltro",
            "setListasPlaneacionHallazgos",
        ]),
        ...mapMutations("listaChequeo", [
            "setFiltroEmpresa",
            "resetSelectedListaChequeo",
            "setAccion",
            "setPermisosAdmin",
            "setPermisosEmpresa",
            "establecerPlaneacionesAuditoriasHallazgos",
            "establecerIdEmpresaSelectedListaChequeo",
            "establecerIdUbicacion",
            "setLocationNameToCheckList",
        ]),
        ...mapMutations("hallazgo", [
            "setParametroSeguimiento",
            "setVerHallazgo",
            "cargaHallazgos",
            "asignarEmpresa",
            "setHallazgoEmpresa",
            "setHallazgo",
            "setFiltroGraficas",
        ]),
        ...mapActions("hallazgo", ["cHallazgo"]),
    },
    beforeDestroy() {
        this.resetSelectedListaChequeo();
    },
    watch: {
        async tabIndex(newValue) {
            switch (newValue) {
                case 0:
                    break;
                case 1:
                    await this.verGraficas();
                    break;
                case 2:
                    await this.verPlanAccion();
                    break;
            }
        },
        "selectedListaChequeo.id_empresa": async function (val) {
            if (!val) return;
            await this.getResponsibles(this.selectedListaChequeo.id_empresa);
        },
    },
    computed: {
        ...mapState("listaChequeo", [
            "tipoSeguimientos",
            "selectedListaChequeo",
            "tipoListaChequeo",
            "accion",
            "empresas",
            "filtro",
            "listaTipoSeguimientos",
            "planeacionesAuditoriasHallazgos",
            "ubicaciones",
        ]),
        ...mapState("hallazgo", ["lista", "hallazgos"]),
        ...mapGetters("planeacionAuditoria", [
            "getEmpresasFil",
            "getChecklist",
        ]),
        ...mapState("findings", ["responsibles"]),
        ...mapState("workers", ["worker"]),
        workersList() {
            if (!this.responsibles.length) return [];
            return this.responsibles.map((worker) => ({
                ...worker,
                fullName: `${worker.names} ${worker.surnames} - ${worker.identification}`,
            }));
        },
    },
};
</script>

<style
    src="../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.min.css"
></style>
<style scoped>
.position-timeline {
    max-height: 200px;
    overflow-y: auto;
}
.position-item {
    padding: 0.5rem 0;
    border-left: 2px solid #dee2e6;
    margin-left: 0.5rem;
    padding-left: 1rem;
    position: relative;
}
.position-item::before {
    content: '';
    position: absolute;
    left: -5px;
    top: 50%;
    width: 8px;
    height: 8px;
    background: #17a2b8;
    border-radius: 50%;
    transform: translateY(-50%);
}
.position-date {
    font-size: 0.875rem;
    color: #6c757d;
    margin-bottom: 0.25rem;
}
.position-info {
    margin-top: 0.25rem;
    max-width: 100%;
}
.position-badge {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/* Mantener los estilos anteriores del avatar */
.avatar-wrapper {
    position: relative;
    display: inline-block;
}
.avatar-circle {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.avatar-circle:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
}
.initials {
    font-size: 2.8rem;
    color: white;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}
.avatar-status {
    position: absolute;
    bottom: 5px;
    right: 5px;
    width: 20px;
    height: 20px;
    background: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.status-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #dc3545;
}
.status-active .status-dot {
    background-color: #28a745;
}
/* Rest of the styles remain the same */
</style>